module.exports = __webpack_public_path__ + "img/online-web-design.b5fb9bd8.png";